import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { IconButton } from "@artprov/design-system";
import Contenido from "./components/Contenido";
import { rendicionesAdapter } from "@/services/adapters/rendicion.adapter";
import { getDetalleDeRendiciones } from "@/services/mis-solicitudes/solicitudes";
import { getAtachmentDetalleSolicitud as getAtachmentDetalleSolicitudHttp } from "@/services/mis-solicitudes/solicitudesService";

export default function Rendiciones() {
  const [rendiciones, setRendiciones] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalAutorizantesOpen, setIsModalAutorizantesOpen] = useState(false)
  const [modalData, setModalData] = useState(null);
  const [total, setTotal] = useState(0);

  const { id } = useParams();

  const getAtachmentDetalleSolicitud = async (id) => {
    if (id) {
      const response = await getAtachmentDetalleSolicitudHttp(id);
      setModalData(response);
      setModalOpen(true);
    }
  };

  const rendicionesAdaptedToDom = (rendiciones) => {
    const rendicionesAdaptedToDom = rendiciones.rows.map((item) => {
      const accionDomElement = React.createElement(IconButton, {
        icon: "visibility",
        tooltip: "Subir comprobante",
        size: "medium",
        className: "text-primary-20",
        idfile: item.idFileComprobante,
        onClick: () => {
          getAtachmentDetalleSolicitud(item.idFileComprobante);
        },
      });

      return { ...item, acciones: accionDomElement };
    });
    return rendicionesAdaptedToDom;
  };

  useEffect(() => {
    const init = async () => {
      let rendicionesData = await getDetalleDeRendiciones(id);
      let rendicionesDataAdapted = rendicionesAdapter(rendicionesData);
      rendicionesDataAdapted = rendicionesAdaptedToDom(rendicionesDataAdapted)
      setRendiciones(rendicionesDataAdapted);
      setTotal(rendicionesData.data.importe_total);
    }
    init();
  }, []);

  return rendiciones?.length > 0 ? (
    <Contenido
      data={rendiciones}
      isModalOpen={isModalOpen}
      modalData={modalData}
      setModalOpen={setModalOpen}
      total={total}
      closeModal={() => {
        setModalOpen(false);
        setModalData(null);
      }}
    />
  ) : null;
}
